var map = {
	"./ajax-loader": 80398,
	"./ajax-loader.gif": 80398,
	"./full-logo": 32306,
	"./full-logo.png": 32306,
	"./icon-logo": 63054,
	"./icon-logo-white": 41922,
	"./icon-logo-white.png": 41922,
	"./icon-logo.png": 63054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86190;